import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    settings: {},
  },
  mutations: {
    setSettings(state, payload) {
      state.settings = payload;
    },
  },
  actions: {
    async getDigitalSettings(
      { commit, rootState: { locations } },
      { suffix = locations.suffix } = {},
    ) {
      try {
        const { data } = await HTTP.get(`${suffix}/settings`);
        commit('setSettings', data || {});
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async setDigitalSettings(
      { commit, rootState: { locations } },
      { suffix = locations.suffix, settings },
    ) {
      try {
        const response = await HTTP.post(`${suffix}/settings`, settings);
        commit('setSettings', response.data || {});
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
};
